/**
 * @generated SignedSource<<5fabdd1393d9963b63ddf562c8bb504b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RegisterUserInput = {
  checkoutId?: string | null;
  email?: string | null;
  verificationCode: string;
};
export type ProductRegistrationVerifyEmailStepMutation$variables = {
  input: RegisterUserInput;
};
export type ProductRegistrationVerifyEmailStepMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly firstName: string | null;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
  };
};
export type ProductRegistrationVerifyEmailStepMutation = {
  response: ProductRegistrationVerifyEmailStepMutation$data;
  variables: ProductRegistrationVerifyEmailStepMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegisterUserResponse",
    "kind": "LinkedField",
    "name": "registerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductRegistrationVerifyEmailStepMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductRegistrationVerifyEmailStepMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "357edb82c6a4ea694a7bf9516f125fc4",
    "id": null,
    "metadata": {},
    "name": "ProductRegistrationVerifyEmailStepMutation",
    "operationKind": "mutation",
    "text": "mutation ProductRegistrationVerifyEmailStepMutation(\n  $input: RegisterUserInput!\n) {\n  response: registerUser(input: $input) {\n    node {\n      id\n      firstName\n      lastName\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ec30d118cf8e74b67f2bbe00bec2fa7";

export default node;
